import {translate} from '../../i18n';

/**
 *
 * @param {File} file
 * @return {Promise}
 */
function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener('load', event => {
            resolve(event.target.result);
        });

        reader.addEventListener('error', event => {
            reject(translate('Failed to read file'));
            reader.abort();
        });

        reader.readAsDataURL(file);
    });
}

/**
 *
 * @param {Blob} blob
 * @param {string} filename
 */
const downloadBlobAsFile = (blob, filename = 'download') => {
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
        return;
    }

    let url = URL.createObjectURL(blob);
    let anchor = document.createElement('a');
    anchor.setAttribute('href', url);
    anchor.setAttribute('download', filename);
    anchor.click();
};

/**
 *
 * @param {string} text
 * @param {function} onSuccess
 * @param {function} onError
 */
const copyToClipboard = (text, onSuccess, onError) => {
    if (!navigator.clipboard) {
        fallbackCopyToClipboard(text);
        return;
    }

    navigator.clipboard.writeText(text).then(function() {
        onSuccess();
    }, function(error) {
        onError(error.message);
    });

    function fallbackCopyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.position = 'fixed';
        textArea.style.top = '-10000px';
        textArea.style.left = '-10000px';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            if (document.execCommand('copy')) {
                onSuccess();
            } else {
                onError(translate('Oops, unable to copy'));
            }
        } catch (error) {
            onError(error.message);
        }

        document.body.removeChild(textArea);
    }
};

export {
    readFileAsDataURL,
    downloadBlobAsFile,
    copyToClipboard
}
